<script>
    import { onMount } from 'svelte';
    import { fetchTwoFaConfig, setupTwoFaConfig } from '/public/services/users/users';
    import ThexaHero from '/shared/c/logo/ThexaHero.svelte';
    import TwoFAProgress from '/public/components/2fa/2FAProgress.svelte';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let name = null;
    let qr = null;
    let stage = 1;
    let otp = null;

    function setStage(n) {
        stage = n;
    }

    function challengeOTP(e) {
        e.preventDefault();
        setupTwoFaConfig(hash,otp).then(res => {
            if (res.success) {
                window.location = res.data.url;
            }
        });
    }

    onMount(() => {
        fetchTwoFaConfig(hash).then(res => {
            if (res.success) {
                name = res.data.name;
                qr = res.data.qr;

                loading = false;
            }
        });
    });

</script>

{#if loading === true}

    <div class="text-center">
        <h4>
            <span class="ajax-ball-loader"></span>
        </h4>
    </div>

{:else}

   <div class="row justify-content-center mt-5">
        <div class="col-sm-12 col-md-12 col-lg-10 col-xl-6 col-xxl-5">
            <div class='row justify-content-center'>
                <div class='col-sm-12 col-md-10 col-lg-8'>
                    <div class='mb-3 text-center'>
                
                        <ThexaHero/>

                    </div>  
                </div>
            </div>                      
            <div class="card">                                

                <div class="card-body p-5">            
                    
                    {#key stage}

                        <TwoFAProgress
                            stage={stage}
                        />

                    {/key}

                    {#if stage == 1}
                        <section>
                            <h3>
                                Install an Authenticator app
                            </h3>
                            <div class='mb-5'>
                                Pick an app for your phone to generate the one-time codes you'll use to sign in.
                            </div>
                            
                            <div class='d-flex flex-column'>
                                <a href='https://authy.com' target='_blank' class='d-flex mb-3 app_link border-bottom pb-2'>                                    
                                    <span class="app_icon flex-shrink-1" style="background:#ec1c24;">
                                        <svg viewBox="0 0 24 24" fill="none"><path d="M7 15.5c0-2.8 2.2-5 5-5 1.4 0 2.6.5 3.5 1.4" stroke="#fff" stroke-width="2.4" stroke-linecap="round"></path><path d="M17 8.5c0 2.8-2.2 5-5 5-1.4 0-2.6-.5-3.5-1.4" stroke="#fff" stroke-width="2.4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                    <span class="flex-grow-1 ms-2">
                                        <span class="app_name fw-bold">Authy</span> <span class="text-muted">iOS · Android · Desktop</span>
                                    </span>
                                    <span class='flex-shrink-1'>
                                        <svg class="app_go" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </span>
                                </a>
                                <a href='https://www.microsoft.com/en-us/security/mobile-authenticator-app' target='_blank' class='d-flex mb-3 app_link border-bottom pb-2'>                                    
                                    <span class="app_icon flex-shrink-1" style="background:#1668de;">
                                        <svg viewBox="0 0 24 24" fill="none"><circle cx="10" cy="8" r="3.2" stroke="#fff" stroke-width="2.1"></circle><path d="M10 11.2v6.5m-2-2h4" stroke="#fff" stroke-width="2.1" stroke-linecap="round"></path></svg>
                                    </span>
                                    <span class="flex-grow-1 ms-2">
                                        <span class="app_name fw-bold">Microsoft Authenticator</span> <span class="text-muted">iOS · Android · Windows</span>
                                    </span>
                                    <span class='flex-shrink-1'>
                                        <svg class="app_go" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </span>
                                </a>
                                <a href='https://support.google.com/accounts/answer/1066447' target='_blank' class='d-flex mb-3 app_link border-bottom pb-2'>                                    
                                    <span class="app_icon flex-shrink-1" style="background:#5f6368;">
                                        <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="7.5" stroke="#fff" stroke-width="2.1"></circle><path d="M12 7.5V12l3 2" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </span>
                                    <span class="flex-grow-1 ms-2">
                                        <span class="app_name fw-bold">Google Authenticator</span> <span class="text-muted">iOS · Android</span>
                                    </span>
                                    <span class='flex-shrink-1'>
                                        <svg class="app_go" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </span>
                                </a>
                            </div>

                            <div class='mb-5'>
                                Already use LastPass or 1Password? Their built-in authenticators work too.
                            </div>

                            
                            <div class="d-grid">                                
                                <button type="button" class="btn btn-primary btn-lg " on:click={() => setStage(2)}>
                                    Continue
                                </button>
                            </div>
                        </section>

                    {/if}

                    {#if stage == 2}

                        <section>
                            <h3>
                                Scan the QR code
                            </h3>                           
                            <div class='mb-5'>
                                In your authenticator app, add an account and scan the code below.
                            </div>
                            <div class="mt-5 mb-5">
                                <div class='row justify-content-center'>
                                    <div class='col-sm-12 col-md-10 col-lg-8 col-xl-6 col-xxl-5'>
                                         <img alt="2FA QR code" src="{ qr }" class="img-fluid d-block mx-auto"/>
                                    </div>
                                </div>                               
                            </div>                            
                            <div class="d-grid mb-2">
                                <button type="button" class="btn btn-primary btn-lg" on:click={() => setStage(3)}>
                                    Continue
                                </button>
                            </div>
                            <div class='d-grid'>
                                <button type='button' class='btn btn-outline-secondary' on:click={() => setStage(1)}>
                                    Back
                                </button>
                            </div>                            
                        </section>

                    {/if}

                    {#if stage == 3}

                        <h3>
                            Enter your code
                        </h3>
                        <div class='mb-3'>
                            Type the 6-digit code from your authenticator app to finish and sign in.
                        </div>                        
                       <form class="form" on:submit={challengeOTP}>
                           <div class="row mb-3">                               
                               <div class="col-sm-12">
                                   <input type="text" id="otp_code" class="form-control" required bind:value={otp} placeholder="Enter your 6-digit code"/>
                               </div>
                            </div>
                            <div class='row mb-3'>
                                <div class="col-sm-12">
                                    <div class='d-grid'>
                                        <button type="submit" class="btn btn-primary btn-lg">
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class='row mb-3'>
                                <div class="col-sm-12">
                                    <div class='d-grid'>
                                        <button type="button" class="btn btn-outline-secondary" on:click={() => setStage(2)}>
                                        Back
                                        </button>
                                    </div>
                                </div>                               
                           </div>
                       </form>

                    {/if}

                </div>
            </div>
        </div>
    </div>

{/if}

<style>
    .app_link {
        text-decoration: none;
    }
    .app_icon {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        display: grid;
        place-items: center;
        flex: none;
    }    
    .app_name {
        line-height: 38px;
    }
    .app_go {
        color: var(--ink-faint);
        flex: none;
        transition: transform .2s, color .2s;
    }
    
</style>